import { render, staticRenderFns } from "./LogOff.vue?vue&type=template&id=52844f26&scoped=true"
import script from "./LogOff.vue?vue&type=script&lang=js"
export * from "./LogOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52844f26",
  null
  
)

export default component.exports